export interface SampleAggregate {
    readonly mean: number;
    readonly sd: number;
    readonly max: number;
    readonly count: number;
}

export function sampleAggregate(
    values: readonly number[]
): SampleAggregate | null {
    if (values.length === 0) {
        return null;
    }
    const mean = values.reduce((sum, v) => sum + v, 0) / values.length;
    const variance =
        values.length > 1
            ? values.reduce((sum, v) => sum + (v - mean) ** 2, 0) /
              (values.length - 1)
            : 0;
    return {
        mean,
        sd: Math.sqrt(variance),
        max: Math.max(...values),
        count: values.length,
    };
}
